var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-download-add" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          staticClass: "add-form",
          attrs: { model: _vm.formData, "label-position": "right" }
        },
        [
          _c(
            "div",
            [
              _c("span", { staticClass: "divider-title" }, [
                _vm._v(_vm._s(_vm.searchInfo.taskName) + "-下载条件筛选")
              ]),
              _c("el-divider")
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 50 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "下载字段：" } }, [
                    _c(
                      "div",
                      { staticClass: "bairun-grey-pannel bairun-margin-b" },
                      [
                        _vm.searchInfo.taskColumnNames
                          ? _c(
                              "div",
                              { staticStyle: { "overflow-x": "auto" } },
                              [
                                _c(
                                  "table",
                                  { staticClass: "download-columns" },
                                  [
                                    _c(
                                      "tr",
                                      _vm._l(
                                        _vm.searchInfo.taskColumnNames.split(
                                          ","
                                        ),
                                        function(item) {
                                          return _c("th", [
                                            _vm._v(_vm._s(item))
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.searchInfo.isNeedStationFilter == 1
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "油站：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "bairun-search-sellers",
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.formData.stationId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "stationId", $$v)
                                    },
                                    expression: "formData.stationId"
                                  }
                                },
                                [
                                  _vm.searchInfo.limitStations.includes("0")
                                    ? _c(
                                        "el-radio",
                                        { attrs: { label: 0, border: "" } },
                                        [_vm._v("总")]
                                      )
                                    : _vm._e(),
                                  _vm._l(_vm.stationOptions, function(item) {
                                    return _c(
                                      "el-radio",
                                      { attrs: { label: item.ID, border: "" } },
                                      [_vm._v(_vm._s(item.stationName))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.searchInfo.isNeedSellerFilter == 1
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "便利店：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "bairun-search-sellers",
                                  attrs: { size: "mini" },
                                  model: {
                                    value: _vm.formData.sellerId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "sellerId", $$v)
                                    },
                                    expression: "formData.sellerId"
                                  }
                                },
                                [
                                  _vm.searchInfo.limitSellers.includes("0")
                                    ? _c(
                                        "el-radio",
                                        { attrs: { label: 0, border: "" } },
                                        [_vm._v("总")]
                                      )
                                    : _vm._e(),
                                  _vm._l(_vm.sellerOptions, function(item) {
                                    return _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          label: item.sellerId,
                                          border: ""
                                        }
                                      },
                                      [_vm._v(_vm._s(item.shortSellerName))]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.searchInfo.isNeedTimeFilter == 1 &&
          _vm.searchInfo.isNeedAfterTimeFilter == 0
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "筛选时间：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: "日期选择",
                                  clearable: false
                                },
                                model: {
                                  value: _vm.formData.startTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "startTime", $$v)
                                  },
                                  expression: "formData.startTime"
                                }
                              }),
                              _vm._v("- "),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: "日期选择",
                                  clearable: false,
                                  "picker-options": _vm.endTimePickerOptions
                                },
                                model: {
                                  value: _vm.formData.endTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "endTime", $$v)
                                  },
                                  expression: "formData.endTime"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.searchInfo.isNeedTimeFilter == 1 &&
          _vm.searchInfo.isNeedAfterTimeFilter == 1
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "筛选时间：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: "日期选择",
                                  clearable: false
                                },
                                model: {
                                  value: _vm.formData.startTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "startTime", $$v)
                                  },
                                  expression: "formData.startTime"
                                }
                              }),
                              _vm._v("- "),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: "日期选择",
                                  clearable: false,
                                  "picker-options": _vm.endTimePickerOptions
                                },
                                model: {
                                  value: _vm.formData.endTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "endTime", $$v)
                                  },
                                  expression: "formData.endTime"
                                }
                              }),
                              _vm._v("        后续时间： "),
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  format: "yyyy-MM-dd HH:mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  placeholder: "日期选择",
                                  clearable: false,
                                  "picker-options": _vm.afterTimePickerOptions
                                },
                                model: {
                                  value: _vm.formData.afterTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "afterTime", $$v)
                                  },
                                  expression: "formData.afterTime"
                                }
                              }),
                              _c("div", [
                                _vm._v(
                                  "提示：筛选" +
                                    _vm._s(_vm.formData.startTime) +
                                    "至" +
                                    _vm._s(_vm.formData.endTime) +
                                    "加过油，在" +
                                    _vm._s(_vm.formData.afterTime) +
                                    "后还有或没有继续来加油的数据"
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.searchInfo.isNeedShiftFilter == 1
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "开始班次：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  disabled:
                                    !_vm.formData.stationId &&
                                    !_vm.formData.sellerId
                                },
                                on: { change: _vm.onStartShiftDateChange },
                                model: {
                                  value: _vm.startShiftDate,
                                  callback: function($$v) {
                                    _vm.startShiftDate = $$v
                                  },
                                  expression: "startShiftDate"
                                }
                              }),
                              _vm._v("        "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "auto" },
                                  attrs: {
                                    disabled: !_vm.startShiftDate,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value: _vm.formData.shiftNoStart,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "shiftNoStart",
                                        $$v
                                      )
                                    },
                                    expression: "formData.shiftNoStart"
                                  }
                                },
                                _vm._l(_vm.startShiftOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.shiftNo,
                                    attrs: {
                                      label: item.shiftName,
                                      value: item.shiftNo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "结束班次：" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "bairun-grey-pannel bairun-margin-b"
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  disabled:
                                    !_vm.formData.stationId &&
                                    !_vm.formData.sellerId
                                },
                                on: { change: _vm.onEndShiftDateChange },
                                model: {
                                  value: _vm.endShiftDate,
                                  callback: function($$v) {
                                    _vm.endShiftDate = $$v
                                  },
                                  expression: "endShiftDate"
                                }
                              }),
                              _vm._v("        "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "auto" },
                                  attrs: {
                                    disabled: !_vm.endShiftDate,
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value: _vm.formData.shiftNoEnd,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "shiftNoEnd", $$v)
                                    },
                                    expression: "formData.shiftNoEnd"
                                  }
                                },
                                _vm._l(_vm.endShiftOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.shiftNo,
                                    attrs: {
                                      label: item.shiftName,
                                      value: item.shiftNo
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.loading },
              on: { click: _vm.onSave }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }